module.exports = __webpack_public_path__ + "assets/img/342ab1e464e4a587e7193f4cf6578c34.png";